import BranchDto from '@/models/Branches/BranchDto';
import LocationDto from '@/models/Locations/LocationDto';
import DepartmentDto from '@/models/Departments/DepartmentDto';
import BookingRoleViewModel from '@/models/BookingRoles/BookingRoleViewModel';
import WorkerDto from '@/models/Workers/WorkerDto';
import CreateWorkerRequest from '@/models/Workers/CreateWorkerRequest';
import ListUtils from '@/lib/listUtils';
import DeskDto from '@/models/Desks/DeskDto';

export default class NewWorkerViewModel {
    id = '';
    worker: CreateWorkerRequest = new CreateWorkerRequest();
    defaultBranch: BranchDto;
    defaultDesk: DeskDto;
    availabilityOptions = ListUtils.availabilityTypes();
    currentStep = 1;
}